const initialState={
	reventas:[],
	reventasEstado:0,
	newReventa:{
				precio_peru:"",
				precio_resto:"",
				precio_argentina:"",
				precio_bolivia:"",
				precio_chile:"",
				precio_colombia:"",
				precio_mexico:"",
				precio_uruguay:""	
			}
};

export default function reventasReducer(state= initialState,action){
	switch(action.type){
		case 'REVENTAS':
     		return {...state,reventas:action.payload};
     	case 'REVENTAS_ESTADO':
     		return {...state,reventasEstado:action.payload};
     	case 'NEW_REVENTA':
     		return {...state,newReventa:{...state.newReventa,...action.payload}};
     	default:
     		return state	

	}
}


